import React from "react";

export default function HeroSection() {
    return (
        <section id="heroSection" className="hero--section">
            <div className="hero--section--content-box">
                <div className="hero--section--content">
                    <p className="section--title"> Hello, I'm Hetvi </p>
                    <h1 className="hero--section--title">
                        <span className="hero--section-title--color">Software</span>{" "}
                        <br />
                        Developer
                    </h1>
                </div>
               {/* <button className="btn btn-primary" onClick={() => window.open("./img/Hetvi Desai_Resume.pdf")}>&nbsp;&nbsp;&nbsp; Resume &nbsp;&nbsp;&nbsp;</button> */}
                <div className="hero--section--social-icon">
                    <a
                        href="https://github.com/DesaiHetvi98?tab=repositories"
                        className="navbar--content"
                        target="_blank"
                        rel="noopener noreferrer">
                        <img src="./img/github.png" alt="Github icon" className="hero--github-logo"/>                  
                    </a>
                    
                    <a
                        href="https://www.linkedin.com/in/hetvi-desai-276a14132/"
                        className="navbar--content"
                        target="_blank"
                        rel="noopener noreferrer">
                            <img src="./img/linkedin.png" alt="Linkedin icon" className="hero--github-logo"/>               
                    </a>
                </div>
            </div>
            <div className="hero--section--img">
                <img src="./img/hero_img_new.png" alt="Hero Section" />

            </div>

        </section>
    );
    
}